import React from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet } from '@react-pdf/renderer'

import Text from './Text'

// Create styles
const styles = StyleSheet.create({
  container: {
    marginBottom: 24,
  },
  title: {
    fontFamily: 'Inter-Bold',
    fontSize: 16,
  },
})

// Create Document Component
export const SecondaryTitle = ({ text }) => (
  <View style={styles.container}>
    <Text style={styles.title}>{text}</Text>
  </View>
)

SecondaryTitle.propTypes = {
  text: PropTypes.string.isRequired,
}
